export default __webpack_public_path__ + "static/media/pb_sudirman.d7b01256.png";